import {parseFlagsCookie} from "./parse-flags-cookie.ts";
import {readCookie} from "./read-cookie.ts";

/**
 * Get the status of a specific feature flag the flags cookie.
 *
 * @param name - The name of the feature flag to retrieve the status
 * for.
 * @returns True if the flag is on, false if it's off, and undefined if the
 * cookie does not contain any information about the flag.
 */
export function getFeatureOverride(name: string): boolean | undefined {
    const cookie = readCookie("flags") || "";
    return parseFlagsCookie(cookie)[name];
}
